import clsx from 'clsx';
import { User } from './types';
import styles from './LeaderItem.module.css';

type Props = {
  user: User;
};

export default function LeaderItem({ user }: Props) {
  const positionChange = user.previousPosition - user.position;
  const showMandatoryOptional = user.mandatoryCount >= 0;

  return (
    <div className={styles.container}>
      <span className={styles.position}>{user.position}</span>
      <div className={styles.detailsContainer}>
        <div>
          <span className={showMandatoryOptional ? styles.name : styles.nameNoDesc}>{user.alias}</span>
          {
            user.previousPosition !== 0 && positionChange !== 0 ? <span className={clsx(styles.orderChange, {
              [styles.positive]: user.position < user.previousPosition,
              [styles.negative]: user.position > user.previousPosition,
            })}>
              {`${user.position < user.previousPosition ? '↑' : '↓'} ${Math.abs(positionChange)}`}
            </span> : null
          }
        </div>
        {
          (showMandatoryOptional) ? 
        <span className={styles.details}>Mandatory - {user.mandatoryCount} &middot; Optional - {user.optionalCount}</span>
        :
        <span></span>
        }
      </div>
      <span className={styles.winnings}>{user.winnings}</span>
    </div>
  );
}
